import { NavLink } from "react-router-dom";

const Logo = () => {
    return (
        <div className="text-content-color font-gotu font-normal w-6/12 my-auto hover:text-main text-2xl lg:text-3xl">
            <NavLink to="/">dh.</NavLink>
        </div>
    );
};

export default Logo;
